import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Select from 'components/Selectors/Select/mobile';
import PaginatorSwitcher from 'components/Paginator/PaginatorSwitcher/desktop';

import useCurrentGifts from 'features/bonusProgram/model/useCurrentGifts';
import CurrentGiftsItem from './CurrentGiftsItem';
import './CurrentGiftsTable.scss';

const b = block('current-gifts-table-desktop');

const CurrentGiftsTable = () => {
  const locale = useSelector(s => s.locale.locale);
  const { values, handlers } = useCurrentGifts();

  const headers = [
    locale.name,
    locale.image,
    locale.points,
    locale.status,
    locale.actions,
  ].map((t, i) => (
    <div className={b('table-cell')} key={i}>
      {t}
    </div>
  ));

  const items = values.items.map(t => (
    <CurrentGiftsItem
      item={t}
      key={t.id}
      onDelete={handlers.handleDeleteGift}
    />
  ));

  return (
    <article className={b()}>
      <div className={b('header')}>
        <div className={b('header-title')}>{locale.result}:</div>
        <div className={b('header-text')}>{locale.elementsOnPage}:</div>
        <div className={b('header-select')}>
          <Select items={values.state.itemsOnPage} onChange={handlers.handleItemsOnPageChange} color="grey" />
        </div>
      </div>

      <section className={b('content')}>
        <div className={b('table')}>
          <div className={b('table-header')}>{headers}</div>
          {!!items.length ? items : <div className={b('no-results')}>{locale.noResults}</div>}
        </div>

        <div className={b('paginator-wrapper')}>
          <div className={b('extra')}>
            <div className={b('extra-info')}>
              {values.count} {locale.records}
            </div>
          </div>
          <PaginatorSwitcher
            count={values.count}
            currentPage={values.state.page}
            onPageClick={handlers.handlePageChange}
            itemsOnPage={{ value: values.activeItemsOnPage }}
          />
        </div>
      </section>
    </article>
  );
};

export default CurrentGiftsTable;
